import { Link, Tooltip } from '@mui/material'

interface ReconcileActionProps {
  label: string
  previousMonthTooltip: string
  classificationTooltip: string
  actionTooltip?: string
  disabled: boolean
  classificationBlocked: boolean
  previousMonthBlocked: boolean
  onClick: () => void
}

const ReconcileAction = ({
  label,
  previousMonthTooltip,
  classificationTooltip,
  actionTooltip,
  disabled,
  classificationBlocked,
  previousMonthBlocked,
  onClick,
}: ReconcileActionProps) => {
  const tooltipText = disabled
    ? classificationBlocked
      ? classificationTooltip
      : previousMonthBlocked
        ? previousMonthTooltip
        : ''
    : actionTooltip || ''

  const reconcileButton = (
    <Link
      component="button"
      variant="body2"
      underline="none"
      onClick={onClick}
      className={`bank-reconcile-action-link${disabled ? ' bank-reconcile-action-link--disabled' : ''}`}
      disabled={disabled}
    >
      {label}
    </Link>
  )

  if (!tooltipText) {
    return reconcileButton
  }

  return (
    <Tooltip
      arrow
      placement="top"
      title={
        <span className="bank-reconcile-classification-tooltip__content">{tooltipText}</span>
      }
      componentsProps={{
        tooltip: { className: 'bank-reconcile-classification-tooltip' },
        arrow: { className: 'bank-reconcile-classification-tooltip__arrow' },
      }}
    >
      <span
        className="bank-reconcile-action-tooltip bank-reconcile-action-tooltip--classification"
        data-testid="reconcile-action-tooltip"
        tabIndex={0}
        aria-label={tooltipText}
      >
        {reconcileButton}
      </span>
    </Tooltip>
  )
}

export default ReconcileAction
